import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { getIsNotFound } from 'utils/getIsNotFound';
import { ApiError } from 'types/api';
import { getInvoiceGMV, type MonthComparablesGMVResponse } from 'api/admin/businesses/barry';

export const useGetInvoiceGMV = (businessId: number, enabled: boolean) => {
  return useQuery<unknown, ApiError, MonthComparablesGMVResponse['results']>({
    queryKey: ['invoiceGMV', businessId],
    queryFn: async () => {
      if (!businessId) {
        return null;
      }

      const { data } = (await getInvoiceGMV(
        businessId,
      )) as AxiosResponse<MonthComparablesGMVResponse>;
      return data.results;
    },
    onError: (error) => {
      Sentry.captureException(error);

      if (!getIsNotFound(error)) {
        toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
          duration: 4000,
        });
      }
      return error;
    },
    enabled,
  });
};
